<template>
  <div id="app">
    <auto-logout/>
    <router-view />
  </div>
</template>

<script>
import "admin-lte/dist/css/adminlte.css";
import "admin-lte/plugins/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "admin-lte/plugins/jquery/jquery";
import AutoLogout from './components/organisms/AutoLogout.vue';
export default {
  components: { AutoLogout },};
</script>

<style>
@media (max-width: 601px) {
  html,
  body {
    overflow-x: hidden;
  }
  .image-group {
    width: 265px!important;
  }
  .preview-image {
    width: 265px!important;
    height: 265px!important;
  }
}
#app {
  font-family: "Roboto", sans-serif;
}
hr {
  border-top: 0 !important;
}
.route-is-active {
  color: #FFFFFF!important;
  background-color: #2f303a!important;
}
/* Scroll bar stylings */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--lightestgrey);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.alert-success {
  color: #155724 !important;
  background-color: #d4edda !important;
  border-color: #c3e6cb !important;
}
.form-control.border-danger,
.form-control.border-danger ~ .input-group-append,
.calendar-input.border-danger {
  animation-name: shakeError;
  animation-fill-mode: forwards;
  animation-duration: 0.6s;
  animation-timing-function: ease-in-out;
}
@keyframes shakeError {
  0% {
    transform: translateX(0);
  }
  15% {
    transform: translateX(0.2rem);
  }
  30% {
    transform: translateX(-0.2rem);
  }
  45% {
    transform: translateX(0.2rem);
  }
  60% {
    transform: translateX(-0.2rem);
  }
  75% {
    transform: translateX(0.2rem);
  }
  90% {
    transform: translateX(-0.2rem);
  }
  100% {
    transform: translateX(0);
  }
}
.image-cropper-style {
  width: 100%;
  height: 400px;
  border: thin solid var(--bs-gray-400);
  background-image: url("~@/assets/svg/no-image.svg");
  background-size: cover;
  background-position: center;
}
.image-exist {
  background-color: #000 !important;
  background-image: none !important;
}
.image-group {
  width: 300px;
  height: 300px;
  position: relative;
}
.image-upload-label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 1.5rem;
  padding: 0.5rem;
  z-index: 1000;
  cursor: pointer;
  color: var(--light);
  background: rgba(0, 0, 0, 0.322);
}
.preview-image {
  width: 300px;
  height: 300px;
  background-color: var(--bs-gray-400);
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
}
.card-footer {
  display: flex;
  flex: 1 1 0px
}
.card-footer > .btn {
  width: 100%;
}
.btn-outline-warning:hover {
  color: #FFFFFF!important;
}
</style>
